import React from 'react';
import { PillarPage } from '../components/marketing/PillarPage';
import { careTransitionsConfig } from '../components/marketing/pillarConfigs';

export default function CareTransitionsPage() {
  return <PillarPage config={careTransitionsConfig} />;
}
